export const sizeClasses = ['large', 'small', 'xsmall'];
export const fontWeight = 700;
export const borderWidth = '1px';
export const borderRadius = '4px';
export const textColor = '#1D4ED8';
export const borderColor = '#BBCAF3';
export const backgroundColor = '#E8EDFB';

export const paddings = {
  large: '0.4rem 0.8rem',
  small: '0.4rem',
  xsmall: '0.2rem 0.4rem',
};

export const fontSizes = {
  large: '1.2rem',
  small: '1rem',
  xsmall: '1rem',
};
